import React from "react";
import { makeStyles, Spinner, Text, typographyStyles } from "@fluentui/react-components";
import classNames from "classnames";
import "./LoadingOverlay.css";

const useStyles = makeStyles({
  text: typographyStyles.subtitle1,
});

export interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {}

export function LoadingOverlay({
  children,
  className,
  ...props
}: React.PropsWithChildren<LoadingOverlayProps>) {
  const styles = useStyles();

  return (
    <div className={classNames("loading-overlay", className)} {...props}>
      <Spinner
        label={<Text className={styles.text}>Loading paragraphs...</Text>}
        labelPosition="below"
        size="huge"
      />
    </div>
  );
}
